<template>
  <div class="header">
    <span class="title">Building Inspection System</span>
    <el-menu
      class="el-menu-demo"
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      :userInfo="userInfo"
      menu-trigger="click"
      active-text-color="#ffd04b">
      <el-submenu index="1">
        <template v-if="userInfo" slot="title">欢迎 {{userInfo.userName}}</template>
        <template v-else slot="title">未登陆</template>

        <el-menu-item v-if="userInfo" index="1-1" @click.native="updatePwd">修改密码</el-menu-item>
        <el-menu-item v-if="userInfo" index="1-2" @click.native="logout">退出登陆</el-menu-item>
      </el-submenu>
    </el-menu>


    <div class="row">
      <el-dialog title="修改密码" :visible.sync="form.dialogFormVisible">

        <input hidden v-model="form.id">

        <el-form :model="form" ref="form" label-width="100px" class="demo-ruleForm"
                 :rules="rules" action="/systemUser/updatePwd">
          <el-form-item label="oldPwd" prop="oldPwd">
            <el-input v-model="form.oldPwd"></el-input>
          </el-form-item>

          <el-form-item label="pwd" prop="pwd">
            <el-input v-model="form.pwd" type="password"></el-input>
          </el-form-item>

          <el-form-item label="pwdConfirm" prop="pwdConfirm">
            <el-input v-model="form.pwdConfirm" type="password"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="form.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Header",
    created:function(){
    },
    data() {
      var validateConfirm = (rule,value,callback) =>{
        if( value != this.form.pwd){
          callback(new Error("两次密码不一致"));
        }else{
          callback();
        }
      };
      return {
        activeIndex: '1',
        activeIndex2: '1',
        userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
        form: {
          dialogFormVisible: false,
          oldPwd: '',
          pwd: '',
          pwdConfirm: ''
        },
        rules: {
          oldPwd: [
            {required: true, message: '请输入原始密码', trigger: 'blur'},
            {min:6, max:15, message:'请输入6到15位密码', trigger:'blur'}],
        pwd:[
          {required:true,message:'请输入新密码',trigger:'blur'},
          {min:6, max:15, message:'请输入6到15位密码', trigger:'blur'}
        ],
        pwdConfirm:[
          {required:true,message:'请确认新密码',trigger:'blur'},
          { validator:validateConfirm, trigger: 'blur' }
        ]}
      };
    },
    mounted: function () {
      console.log(this.userInfo);
    },
    methods: {
      updatePwd: function () {
        this.form.dialogFormVisible = true;
      },
      submit:function () {
        this.$refs.form.validate(validate=>{
          if(!validate){
            return false;
          }

          this.$http.post(this.$refs.form.$attrs.action,{
            id: this.userInfo.id,
            oldPwd: this.form.oldPwd,
            password: this.form.pwd,
            confirm: this.form.pwdConfirm
          }).then(response=>{
            var _this = this;
            if(response.data.code == "1"){
              this.form.dialogFormVisible = false;
              this.$message.success("密码修改成功");
              sessionStorage.removeItem("usreInfo");
              sessionStorage.removeItem("token");
              setTimeout(()=>_this.$router.replace("/login"),500);
            }
          })

        });
      },
      logout: function () {
        var _this = this;
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userInfo");
        setTimeout(function () {
          _this.$router.replace("/login")
        }, 200)
      }
    }
  }
</script>

<style scoped>
  .header {
    top: 0;
    left: 0;
    right: 0;
  }

  .el-menu--horizontal > .el-submenu {
    float: right;
    margin-right: 10px;
  }

  .title {
    position: absolute;
    color: #fff;
    display: inline-block;
    z-index: 2;
    height: 57px;
    line-height: 57px;
    font-weight: bold;
    font-size: 120%;
    left: 20px;
    letter-spacing: 2px;
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue